import React, { useState } from "react";
import { Link } from "@reach/router";
import styles from "./MammalChampion.module.scss";
import Username from "./Username";

function JoinComponent(props) {
  const folk = props.folk;
  const alpha = props.alpha;

  return (
    <>
      <p>
        If you've visited before and already made your decision, feel free to:
      </p>
      <p>
        <Link className={styles.choice} to={"/" + alpha + "/" + folk + ""}>
          Join Now
        </Link>
      </p>
    </>
  );
}

export default JoinComponent;
